<template>
  <v-container class="max-width-1200">

    <!-- infographic -->
    <!-- <v-row>
      <v-col>
        <v-img
          src="https://www.rubin.hu/wp-content/uploads/2015/05/rendszerterv-1.png"
          max-width="800"
          contain
          class="ml-12 mx-auto">
        </v-img>
      </v-col>
    </v-row> -->

    <v-row class="text-justify justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col>
            <!-- main text -->
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('tempering.technology.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('tempering.technology.subtitle')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('tempering.technology.text')}}
              </v-col>
            </v-row>
            <v-row>
              <!-- Rubin COOL -->
              <v-col cols="12" md="6">
                <v-hover
                  v-slot="{ hover }">
                  <v-card
                    flat>
                    <v-img
                      height="350px"
                      src="@/assets/img/em-tempering-technology-01.jpeg">
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="px-4 d-flex flex-wrap transition-fast-in-fast-out primary darken-2 overlay-hover white--text"
                          style="height: 100%;">
                            <v-row class="mx-0">
                            <v-col cols="12" class="pb-0 display-2">
                              {{ $t("tempering.rubinCool.title") }}
                            </v-col>
                            <v-col cols="12" class="pt-0 overline">
                              {{ $t("tempering.rubinCool.subtitle") }}
                            </v-col>
                            <v-col cols="12">
                              {{ $t("tempering.rubinCool.text") }}
                            </v-col>
                          </v-row>
                        </div>
                      </v-expand-transition>
                      <v-row class="white--text fill-height align-end overlay">
                        <v-col cols="12" class="px-8 title text-start">
                          <!-- {{ item.title }} -->
                        </v-col>
                        <v-col v-if="!hover" cols="12" class="px-8 text-start">
                          <span class="display-2">
                            {{ $t("tempering.rubinCool.title") }}
                          </span><br>
                          <span class="overline">
                            {{ $t("tempering.rubinCool.subtitle") }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-img>
                  </v-card>
                </v-hover>
                <v-btn
                  text
                  class="mt-4"
                  id="study_1" name="study" title="study"
                  @click="showStudy(0, 'studyText')">
                  {{ $t("common.readStudy") }}
                  <v-icon>
                    mdi-chevron-double-right
                  </v-icon>
                </v-btn>
              </v-col>
              <!-- RubiCON -->
              <v-col cols="12" md="6">
                <v-hover
                  v-slot="{ hover }">
                  <v-card
                    flat>
                    <v-img
                      height="350px"
                      src="@/assets/img/em-tempering-technology-02.jpeg">
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="px-4 d-flex flex-wrap transition-fast-in-fast-out primary darken-2 overlay-hover white--text"
                          style="height: 100%;">
                          <v-row class="mx-0">
                            <v-col cols="12" class="pb-0 display-2">
                              {{ $t("tempering.rubicon.title") }}
                            </v-col>
                            <v-col cols="12" class="pt-0 overline">
                              {{ $t("tempering.rubicon.subtitle") }}
                            </v-col>
                            <v-col cols="12">
                              {{ $t("tempering.rubicon.text") }}
                            </v-col>
                          </v-row>
                        </div>
                      </v-expand-transition>
                      <v-row class="white--text fill-height align-end overlay">
                        <v-col cols="12" class="px-8 title text-start">
                          <!-- {{ item.title }} -->
                        </v-col>
                        <v-col v-if="!hover" cols="12" class="px-8 text-start">
                          <span class="display-2">
                            {{ $t("tempering.rubicon.title") }}
                          </span><br>
                          <span class="overline">
                            {{ $t("tempering.rubicon.subtitle") }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-img>
                  </v-card>
                </v-hover>
                <v-btn
                  text
                  class="mt-4"
                  id="study_2" name="study" title="study"
                  @click="showStudy(1, 'studyText')">
                  {{ $t("common.readStudy") }}
                  <v-icon>
                    mdi-chevron-double-right
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

    <!-- studies -->
    <v-row id="studyText">
      <v-expansion-panels
        v-model="panel"
        accordion
        flat>
        <v-expansion-panel>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" class="pb-0 display-2">
                {{ $t("tempering.rubinCool.title") }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-justify">
                <RubinCool></RubinCool>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" class="pb-0 display-2">
                {{ $t("tempering.rubicon.title") }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-justify">
                <RubiCon></RubiCon>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <!-- partners -->
    <v-row class="py-8 text-left justify-center">
      <v-col style="display:contents;">
        <div
          v-for="(item,index) in partners"
          :key="index"
          class="ma-4">
            <img
              :src="item.img"
              loading="lazy"
              :alt="item.name + ' logó'"
              height="30" :width="item.width"
              style="object-fit:contain;">
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';
  import RubinCool from '@/components/Studies/Rubincool';
  import RubiCon from '@/components/Studies/Rubicon-biatorbagy';

  export default {
    name: 'TemperingTechnology',
    extends: DataComponentBase,

    components: {
      RubinCool,
      RubiCon,
    },

    data: () => ({
      panel: null,
      partners: [
        { img: require("@/assets/partners/partner_antennahungaria.png"),     name: "Antenna Hungária",    width: '86'  },
        { img: require("@/assets/partners/partner_magyartelekom.png"),       name: "Magyar Telekom",      width: '128'  },
        { img: require("@/assets/partners/partner_vodafone.png"),            name: "Vodafone",            width: '123'  },
      ],
    }),

    methods: {
      showStudy(panel, id) {
        this.panel = panel;
        this.scrollTOSection(id);
      },
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      },
    },
  }
</script>
